import React from "react";

import { ChangePasswordForm, Header } from "../../components";

export const ChangePassword = () => (
  <>
    <Header />
    <ChangePasswordForm />
  </>
);

export default ChangePassword;
